import {webRequest, webNoTokenRequest} from '../api'

// 續租頁面
// {
//     "contractCid" : "",
// }
export function getRenewalContract(params) {
    return webRequest({
        url:'/v1/oauth/management/booking/renewal/page',
        method:'get',
        params: params,
    })
}

// 發起續租
export function setRenewal(data) {
    return webRequest({
        url:'/v1/oauth/management/booking/renewal/initiate',
        method:'post',
        data: data,
    })
}


// WEBPACK FOOTER //
// ./src/apis/company/renewalContract.js